<template>
	<v-container fluid style="height: 100vh; overflow-y: auto">
		<div class="mb-2 text-h4">
			Ordenes de trabajo
			<v-btn
				class="ml-2"
				icon
				large
				depressed
				@click="exportTableToExcel('table', `certificados-${$route.params.mes}`)"
			>
				<v-icon color="green">mdi-microsoft-excel</v-icon>
			</v-btn>
			<v-btn class="ml-2" icon large depressed to="/places">
				<v-icon color="primary">
					mdi-office-building-marker-outline
				</v-icon>
			</v-btn>
		</div>
		<v-row>
			<v-col v-if="ordersPlaces.length" cols="12" class="mb-10">
				<div style="overflow-x: auto">
					<table id="table">
						<thead>
							<tr>
								<th
									v-for="(header, i) in headers"
									:key="i"
									class="body-2 font-weight-medium text-left pl-2"
								>
									{{ header }}
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, k) in ordersSort" :key="k">
								<td class="text-left caption pl-2">{{ item.id }}</td>
								<td class="text-left caption pl-2">{{ item.date }}</td>
								<td class="text-left caption pl-2">
									{{ item.address }}
								</td>
								<td class="text-left caption pl-2">{{ item.type }}</td>
								<td class="text-left caption pl-2">
									{{ item.person.firstName }} {{ item.person.lastName }}
								</td>

								<td class="text-left caption pl-2">
									<span v-if="item.product[0]"
										>{{ item.product[0].producto && item.product[0].producto }}
									</span>

									<span v-if="item.product[1]"
										>{{ item.product[1].producto && item.product[1].producto }}
									</span>

									<span v-if="item.product[2]"
										>{{ item.product[2].producto && item.product[2].producto }}
									</span>

									<span v-if="item.product[3]"
										>{{ item.product[3].producto && item.product[3].producto }}
									</span>

									<span v-if="item.product[4]"
										>{{ item.product[4].producto && item.product[4].producto }}
									</span>
								</td>
								<td class="text-left caption pl-2">
									<span v-if="item.product[0]"
										>{{ item.product[0].isp && item.product[0].isp }}
									</span>

									<span v-if="item.product[1]"
										>{{ item.product[1].isp && item.product[1].isp }}
									</span>

									<span v-if="item.product[2]"
										>{{ item.product[2].isp && item.product[2].isp }}
									</span>

									<span v-if="item.product[3]"
										>{{ item.product[3].isp && item.product[3].isp }}
									</span>

									<span v-if="item.product[4]"
										>{{ item.product[4].isp && item.product[4].isp }}
									</span>
								</td>

								<td class="text-left caption pl-2">
									<span v-if="item.product[0]"
										>{{ item.product[0].dosis && item.product[0].dosis }}
									</span>

									<span v-if="item.product[1]"
										>{{ item.product[1].dosis && item.product[1].dosis }}
									</span>

									<span v-if="item.product[2]"
										>{{ item.product[2].dosis && item.product[2].dosis }}
									</span>

									<span v-if="item.product[3]"
										>{{ item.product[3].dosis && item.product[3].dosis }}
									</span>

									<span v-if="item.product[4]"
										>{{ item.product[4].dosis && item.product[4].dosis }}
									</span>
								</td>
								<td class="text-left caption pl-2">
									<span v-if="item.product[0]"
										>{{
											item.product[0].numeroCebos &&
												item.product[0].numeroCebos
										}}
									</span>

									<span v-if="item.product[1]"
										>{{
											item.product[1].numeroCebos &&
												item.product[1].numeroCebos
										}}
									</span>

									<span v-if="item.product[2]"
										>{{
											item.product[2].cantidadAplicada &&
												item.product[2].cantidadAplicada
										}}
									</span>

									<span v-if="item.product[3]"
										>{{
											item.product[3].cantidadAplicada &&
												item.product[3].cantidadAplicada
										}}
									</span>

									<span v-if="item.product[4]">{{
										item.product[4].cantidadAplicada &&
											item.product[4].cantidadAplicada
									}}</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</v-col>
			<v-col cols="12" v-if="!lodgings.length && !loading">
				<data-empty
					:title="`Sin OT's.`"
					:msj="`Selecione un mes diferente o cambie su palabra filtro`"
				/>
			</v-col>
			<v-overlay absolute v-if="loading" :value="loading">
				<v-progress-circular color="primary" indeterminate size="48"></v-progress-circular>
			</v-overlay>
		</v-row>
	</v-container>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
export default {
	name: 'ListWorkOrders',
	components: {
		DataEmpty: () => import('@/components/ui/DataEmpty'),
	},
	data() {
		return {
			loading: false,
			menuOT: false,
			month: '',
			dialog: false,
			certificateValues: { lodId: '', type: '', index: 0, ot: null },
			filter1: '',
			filter2: '',
			headers: [
				'Folio',
				'Fecha',
				'Dirección',
				'Tratamiento',
				'Tecnico',
				'Producto',
				'ISP',
				'Dosis',
				'Cantidad',
			],
		};
	},
	computed: {
		dateFormatted() {
			return this.month ? moment(this.month).format('MMMM YYYY') : '';
		},
		ordersPlaces() {
			let orders = [];
			this.lodgings.forEach(lod => {
				if (lod.workOrder.length) {
					lod.workOrder.forEach((wo, index) => {
						if (moment(wo[1]).isSame(this.month, 'month'))
							orders.push({
								id: wo.id,
								date: moment(wo.date).format('YYYY-MM-DD'),
								address: `${wo.data[1]}, ${wo.data[2]}`,
								person: this.getPerson(lod.person),
								product: wo.data[20],
								type: wo.data[21].type,
								lodId: lod._id,
								index: wo.index,
								place: wo.data[0],
								isCertificate: lod.workOrder.some(
									el => el.id == wo.id && el.type == 'rrplagas-certificate'
								),
								url: this.generateWorkOrderLink(wo.type, lod._id, index),
								certificate: this.generateWorkOrderCertify(wo.type, lod._id, index),
							});
					});
				}
			});
			return orders.sort((a, b) => b.id - a.id);
		},
		ordersSort() {
			let orders = this.ordersPlaces.filter(or => {
				let numOT = 'ot' + or.id;
				let filter1 = true;
				let filter2 = true;
				if (this.filter1) {
					filter1 =
						numOT.indexOf(this.filter1) > -1 ||
						or.type.toLowerCase().indexOf(this.filter1.toLowerCase()) > -1 ||
						or.person.firstName.toLowerCase().indexOf(this.filter1.toLowerCase()) >
							-1 ||
						or.date.indexOf(this.filter1.toLowerCase()) > -1 ||
						or.place.toLowerCase().indexOf(this.filter1.toLowerCase()) > -1;
				}
				if (this.filter2) {
					filter2 =
						numOT.indexOf(this.filter2) > -1 ||
						or.date.indexOf(this.filter2.toLowerCase()) > -1 ||
						or.place.toLowerCase().indexOf(this.filter2.toLowerCase()) > -1 ||
						or.type.toLowerCase().indexOf(this.filter2.toLowerCase()) > -1 ||
						or.person.firstName.toLowerCase().indexOf(this.filter2.toLowerCase()) > -1;
				}
				return filter1 && filter2;
			});
			return orders.sort((a, b) => moment(b.date) - moment(a.date));
		},
		...mapGetters({
			lodgings: 'Lodging/lodgings',
			listPerson: 'Person/persons',
		}),
	},
	created() {
		this.month = this.$route.params.mes;
	},
	async mounted() {
		this.loading = true;
		if (!this.lodgings.length) {
			await this.getPersonsByAdmin();
			await this.getLodgingsOfAdmin();
		}
		this.loading = false;
	},
	methods: {
		generateWorkOrderLink(type, lodId, index) {
			return `#/${type}/${lodId}/work-order/${index}`;
		},
		generateWorkOrderCertify(type, lodId, index) {
			return `#/${type}/certificate/${lodId}/work-order/${index}`;
		},
		getPerson(id) {
			return this.listPerson.find(person => person._id == id);
		},
		exportTableToExcel(tableID, filename = '') {
			var downloadLink;
			var dataType = 'application/vnd.ms-excel';
			var tableSelect = document.getElementById(tableID);
			var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename ? filename + '.xls' : 'excel_data.xls';

			// Create download link element
			downloadLink = document.createElement('a');

			document.body.appendChild(downloadLink);

			if (navigator.msSaveOrOpenBlob) {
				var blob = new Blob(['\ufeff', tableHTML], {
					type: dataType,
				});
				navigator.msSaveOrOpenBlob(blob, filename);
			} else {
				// Create a link to the file
				downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

				// Setting the file name
				downloadLink.download = filename;

				//triggering the function
				downloadLink.click();
			}
		},
		...mapActions({
			getLodgingsOfAdmin: 'Lodging/getLodgingsOfAdmin',
			getPersonsByAdmin: 'Person/getPersonsByAdmin',
		}),
	},
};
</script>

<style lang="scss">
th {
	min-width: 90px !important;
}
table {
	min-width: 900px;
	width: 100%;
	font-size: 10px !important;
}
tbody td {
	height: 30px !important;
}

tbody tr:nth-child(odd) {
	background-color: #a78acc24;
}

* {
	color: black;
	font-size: 14px;
	-webkit-print-color-adjust: exact !important;
	color-adjust: exact !important;
}
/* Tamaño pagina 1056 1392 px  */
@media print {
	.no-display {
		display: none;
	}
	@page {
		size: 11in 14.5in;
		margin-top: 20px;
	}
}

.row-td-block {
	width: max-content;
}
.center {
	display: block;
	margin-left: auto;
	margin-right: auto;
}
.work-history {
	th {
		min-width: 90px !important;
	}
	table {
		font-size: 10px !important;
	}
	tbody td {
		padding-right: 10px;
		padding-left: 10px;
		height: 10px !important;
	}

	tbody tr:nth-child(odd) {
		background-color: #545fc41c;
	}
}
.row-td-block {
	width: max-content;
}
</style>
